import { setupI18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { useMemo } from 'react';

import { FaqPageContent } from '#features/faq/components/FaqPageContent';
import { messages as enMessages } from '#features/i18n/locales/en/messages.po';
import { messages as ruMessages } from '#features/i18n/locales/ru/messages.po';

/** Actual FAQ controls with a local locale, without changing the viewer's profile. */
export const Route = createFileRoute('/{-$locale}/_layout/preview/faq-controls')({
  ssr: false,
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  validateSearch: (search: Record<string, unknown>) => ({
    lang: search.lang === 'en' ? ('en' as const) : ('ru' as const),
  }),
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
  component: FaqControlsPreview,
});

function FaqControlsPreview() {
  const { lang } = Route.useSearch();
  const i18n = useMemo(
    () => setupI18n({ locale: lang, messages: { en: enMessages, ru: ruMessages } }),
    [lang]
  );
  return (
    <I18nProvider i18n={i18n}>
      <FaqPageContent key={lang} />
    </I18nProvider>
  );
}
